import { useEffect, useState } from 'react';

/**
 * Hook to wait for Google Maps Places API to be loaded
 * Relies on @vis.gl/react-google-maps APIProvider - does NOT load the script itself
 * @param {string} apiKey - Google Maps API key (not used, kept for compatibility)
 * @returns {boolean} Whether the Places API is loaded
 */
export const useGoogleMaps = (apiKey) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Check if already loaded
        if (window.google?.maps?.places?.AutocompleteSuggestion) {
            setIsLoaded(true);
            return;
        }

        // Wait for places library to be available (loaded by APIProvider in App.jsx)
        const checkLoaded = setInterval(() => {
            if (window.google?.maps?.places?.AutocompleteSuggestion) {
                setIsLoaded(true);
                clearInterval(checkLoaded);
            }
        }, 100);

        // Timeout after 15 seconds
        const timeout = setTimeout(() => {
            clearInterval(checkLoaded);
            console.warn('Google Maps Places API not loaded after 15 seconds');
        }, 15000);

        return () => {
            clearInterval(checkLoaded);
            clearTimeout(timeout);
        };
    }, []);

    return isLoaded;
};
